import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import Modal from 'component/utils/Modal'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

export const MODAL_TYPE = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
}

const FIELDS = ['idDatasheetFormatList']

const DatasheetManagementModal = (props) => {
  const {
    closeModal,
    datasheetFormatList,
    editExisting,
    fields,
    handleDelete,
    handleSave,
    modalItem,
    modalType,
    setValueToField,
    translate,
    values,
  } = props

  const datasheetFormatOptions = datasheetFormatList.map((df) => ({
    value: df.idDatasheetFormat,
    label: df.nmDatasheetFormat,
  }))

  const getName = (name) =>
    typeof name === 'object' ? name.props.children : name

  const renderContent = () => {
    switch (modalType) {
      case MODAL_TYPE.EDIT:
        return (
          <section className='modal-container modal-edit-container'>
            {editExisting ? (
              <h4>
                <strong>
                  {translate('datasheetManagement.formatEditTitle')}
                </strong>
              </h4>
            ) : null}
            <ul>
              {modalItem.sectionId && (
                <li>
                  <strong>{translate('section')}</strong>{' '}
                  {getName(modalItem.sectionIdNm).replace(/\d.* - /g, '')}
                </li>
              )}
              {modalItem.subSectionId && (
                <li>
                  <strong>{translate('subSection')}</strong>{' '}
                  {getName(modalItem.subSectionIdNm)}
                </li>
              )}
              {modalItem.typeId && (
                <li>
                  <strong>{translate('type')}</strong>{' '}
                  {getName(modalItem.typeIdNm)}
                </li>
              )}
              {modalItem.subTypeId && (
                <li>
                  <strong>{translate('subType')}</strong>{' '}
                  {getName(modalItem.subTypeIdNm)}
                </li>
              )}
            </ul>
            {editExisting ? (
              <h4>
                <strong>
                  {translate('datasheetManagement.formatEditFooter')}
                </strong>
              </h4>
            ) : null}

            <form onSubmit={beforeHandleSave}>
              <Row>
                <Col xs={12} md={6}>
                  <Field
                    {...fields.idDatasheetFormatList}
                    hint={translate('datasheetManagement.format')}
                  >
                    <Select
                      className='react-select'
                      classNamePrefix='react-select'
                      closeMenuOnSelect={false}
                      isMulti
                      menuPortalTarget={document.body}
                      name='idDatasheetFormatList'
                      onChange={(options) =>
                        setValueToField(
                          'idDatasheetFormatList',
                          options ? options.map((option) => option.value) : []
                        )
                      }
                      options={datasheetFormatOptions}
                      placeholder=''
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      value={datasheetFormatOptions.filter((option) =>
                        values.idDatasheetFormatList.some(
                          (value) => option.value === value
                        )
                      )}
                    />
                  </Field>
                </Col>
              </Row>

              <Row className='margin-top-double'>
                <Col mdOffset={2} xs={12} md={4}>
                  <button
                    onClick={() => closeModal()}
                    type='button'
                    className='button button-danger button-full'
                  >
                    {translate('cancel_button')}
                  </button>
                </Col>

                <Col xs={12} md={4}>
                  <button
                    disabled={!values.idDatasheetFormatList.length}
                    className='button button-primary button-full'
                  >
                    {translate('save_button_label')}
                  </button>
                </Col>
              </Row>
            </form>
          </section>
        )
      case MODAL_TYPE.DELETE:
        return (
          <section className='modal-container modal-delete-container'>
            <p>{translate('datasheetManagement.delete.message')}</p>

            <Row className='margin-top-double'>
              <Col mdOffset={2} xs={12} md={4}>
                <button
                  onClick={() => handleDelete()}
                  type='button'
                  className='button button-danger button-full'
                >
                  {translate('exclude_button')}
                </button>
              </Col>

              <Col xs={12} md={4}>
                <button
                  onClick={() => closeModal()}
                  type='button'
                  className='button-hollow button-hollow-primary  button-full'
                >
                  {translate('cancel_button')}
                </button>
              </Col>
            </Row>
          </section>
        )
      default:
        return <section />
    }
  }

  const beforeHandleSave = (event) => {
    event.preventDefault()

    handleSave({ ...modalItem, ...values })
  }

  return (
    <Modal size='large' closeModal={closeModal}>
      {renderContent()}
    </Modal>
  )
}

DatasheetManagementModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  datasheetFormatList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  modalItem: PropTypes.object.isRequired,
  modalType: PropTypes.string.isRequired,
  editExisting: PropTypes.bool.isRequired,
  setValueToField: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(DatasheetManagementModal)

export { DatasheetManagementModal }
